import { createContext, useContext } from "react";

const ConversationUrnContext = createContext(null);

export const ConversationUrnProvider = ConversationUrnContext.Provider;

export function useConversationUrnContext(): string {
  return useContext(ConversationUrnContext);
}
